import sileo from 'sileo';
import axios from 'source/lib/axios';
const SimplePayrollPeriod = new sileo.Model('bposeats', 'simple-payroll-period');
const PayrollPeriodList = new sileo.Model('bposeats', 'payroll-periods');
const AdminEmploymentPolicies = new sileo.Model('bposeats', 'admin-employment-policies');
const AdminPayrollPeriod = new sileo.Model('hqzen', 'admin-employee-payrolls');
const PayrollPeriod = new sileo.Model('bposeats', 'admin-payrolls-periods');
const EmployeeDailyHourBreadown = new sileo.Model('hqzen', 'employee-daily-hour-breakdown');
const HRPayrolls = new sileo.Model('applybpo', 'hr-payrolls');
const EmployeePayroll = new sileo.Model('hqzen', 'employee-payroll');
const EmployeeTeam = new sileo.Model('applybpo', 'hr-employee-teams');
const EmployeeDepartment = new sileo.Model('applybpo', 'hr-employee-departments');
const HRPayrollPolicy = new sileo.Model('applybpo', 'hr-payroll-policy');
const ApplyBPOPayrollPeriod = new sileo.Model('applybpo', 'payroll-period');

const state = {
    employmentPolicies: [],
    selectedEmploymentPolicyId: -1,
    loading: false,
};

const getters = {
    selectedEmploymentPolicy(state) {
        return state.employmentPolicies.find(
            el => el.pk === state.selectedEmploymentPolicyId);
    },

    loadingPolicies: (state) => state.loading,
};
const mutations = {
    toggleLoading(state, status) {
        state.loading = status;
    },

    setEmploymentPolicies(state, employmentPolicies) {
        state.employmentPolicies = employmentPolicies;
    },

    setSelectedEmploymentPolicyId(state, id) {
        state.selectedEmploymentPolicyId = id;
    }
};

const actions = {
    fetchSimplePayrollPeriods(context, filters) {
        return PayrollPeriodList.objects.filter(filters);
    },

    getSimplePayrollPeriod(context, pk) {
        return SimplePayrollPeriod.objects.get(pk);
    },

    fetchAdminEmploymentPolicies(context, filters) {
        return AdminEmploymentPolicies.objects.filter(filters);
    },

    fetchAdminEmployeePayrolls(context, filters) {
        return AdminPayrollPeriod.objects.filter(filters);
    },

    fetchAdminEmployeePayrollsPeriod(context, filters) {
        return PayrollPeriod.objects.filter(filters);
    },

    validatePayrollCSV(_, data) {
        return axios
            .post('applybpo/employee_payrolls/validate-csv', data)
            .then(response => response);
    },

    getPayrollCSVHeadersAndSubheaders(_, params) {
        return axios
            .get('applybpo/employee_payrolls/payroll-csv-headers-and-subheaders', {
                params: params
            })
            .then(response => response);
    },

    fetchPayrollCSVAmazonFormData() {
        return axios
            .get('applybpo/employee_payrolls/get-payroll-csv-amazon-form-data')
            .then(response => response)
            .catch(error => error);
    },

    checkIfCSVValidateJobStarted(_, params) {
        return axios
            .get('applybpo/employee_payrolls/check-validate-csv-started', {
                params
            })
            .then(response => response);
    },

    /**
     * Fetches the employee's daily hour breakdown based on the provided filters.
     *
     * @typedef {Object} Filters - The filters to apply when fetching the employee's daily hour breakdown.
     * @property {string} employment_id - The employment ID of the employee.
     * @property {string} date - The date of the daily hour breakdown
     * @property {string} payroll_period_id - The payroll period ID of the daily hour breakdown
     *
     * @param {any} _ - Placeholder for the unused parameter.
     * @param {Filters} filters - The filters to apply when fetching the employee's daily hour breakdown.
     * @returns {Promise<Array>} A promise that resolves to an array of employee daily hour breakdown objects.
     */
    fetchEmployeeDailyHourBreakdown(_, filters) {
        return EmployeeDailyHourBreadown.objects.filter(filters);
    },

    async createEmployeePayrolls(context, data) {
        const formData = new FormData();
        Object.keys(data).forEach(key => formData.append(key, data[key]));
        return await HRPayrolls.objects.create(formData);
    },

    fetchEmployeePayrolls(context, filters) {
        return EmployeePayroll.objects.filter(filters).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    updatePayrollPeriods(context, data) {
        const form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            form.append(key, value);
        }

        return ApplyBPOPayrollPeriod.objects.update({}, form).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },

    fetchEmployeeDepartments(context, filters) {
        return EmployeeDepartment.objects.filter(filters);
    },

    generatePayrollHistoryCSV(context, params) {
        return axios.get('applybpo/employee_payrolls/generate-payroll-history-csv', {
            params: params
        }).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    checkCSVUploadStatus(context, params) {
        return axios.get('applybpo/employee_payrolls/csv-upload-status', {
            params: params
        }).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    fetchEmployeeTeams(context, filters) {
        return EmployeeTeam.objects.filter(filters);
    },

    checkIfCSVGenerateJobStarted(_, params) {
        return axios
            .get('applybpo/employee_payrolls/check-generate-csv-started', {
                params
            })
            .then(response => response);
    },

    getPayrollPolicy(context, pk) {
        return HRPayrollPolicy.objects.get(parseInt(pk)).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};
